import styled from 'styled-components';

export const FormContent = styled.div`
  position: relative;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  z-index: 2;
  overflow: hidden;

  .forget-password-wrap {
    width: 100%;
    text-align: right;
  }

  .forget-password {
    flex-shrink: 0;
    color: var(--spacepurple);
    border: none;
    margin: 10px 0;
    margin-left: auto;
    text-align: right;
    font-weight: 500;
  }

  h1 {
    font-weight: 800;
    font-size: 24px;
    line-height: 1.1;
    text-align: center;
    color: var(--ink);
    letter-spacing: -0.035em;
    text-transform: none;

    @media (min-width: 768px) {
      font-size: 30px;
    }
  }
  .text-content {
    text-align: center;
  }

  .otp-wrapper {
    margin-bottom: 30px;
  }
  .image-wrap-mail {
    max-width: 150px;
    width: 100%;
    margin: 38px auto;
  }
  .text-wrapper {
    width: 100%;
  }
  .heading-text {
    margin-bottom: 30px;

    p {
      i {
        font-weight: 700;
        color: var(--primary);
      }
    }
  }
  .privacy {
    text-align: left;
    max-width: 200px;
    font-size: 13px;
    line-height: 17px;
    color: var(--mute);

    @media (min-width: 768px) {
      max-width: 225px;
    }

    p {
      margin: 0;
      color: var(--mute);

      .color {
        color: var(--spacepurple);
        font-weight: 600;
      }
    }
  }

  .footer {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    padding: 15px 20px;
    color: var(--mute);
    a {
      color: var(--spacepurple);
      font-weight: 700;
    }
  }

  .text-box {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 13px;
    line-height: 17px;
    margin: 0 0 20px;
    color: var(--mute);
  }

  .formWrapper {
    text-align: left;

    label,
    .label {
      color: var(--ink);
      font-weight: 500;
      font-size: 14px;
    }

    button {
      margin-bottom: 15px;
    }
  }
`;

export const SuccessContent = styled.div`
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
  text-align: center;

  .img-box {
    width: 216px;
    margin: 0 auto 35px;

    img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  .title {
    display: block;
    font-size: 25px;
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 30px;
    color: var(--ink);
  }
`;
